import { connect } from "react-redux";
import App from "../views/app";
import { sessionSlice } from "../../store/sessionSlice";

const mapStateToProps = (state) => {
  return {
    isVrUser: state.session.isVr,
    isAdmin: state.session.userType === "admin",
    isTouch: state.session.isTouch,
    isTryingRoom: state.session.isTryingRoom,
    isShowingHelp: state.session.isShowingOverlay,
    isOnline: state.session.isConnected,
    isOrbitControls: state.scene.isOrbitControls,
    status: state.session.sessionStatus,
    isConnectedToASession: state.session.sessionStatus === "ACTIVE" || state.session.sessionStatus === "MINIMIZING",
    isLoading: state.session.sessionStatus === "LOADING_ROOM" || state.session.sessionStatus === "LOADING_SCENE",
    isSimulation: state.session.sessionType !== "ELEMENTS", 
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onStartConnecting: (data) => {
      dispatch(sessionSlice.actions.startConnecting());
    },
  };
};

export const ApplicationContainer = connect(mapStateToProps, mapDispatchToProps)(App);
